import React, { ReactNode, createContext, useContext } from 'react';

import useAllServicesLoader from './useAllServicesLoader';

import { ServiceLoaderResults } from './types';

// Only exported so that unit tests can create a provider passing mock data
export const AllServicesContext = createContext<ServiceLoaderResults | null>(
  null
);

type AllServicesProviderProps = {
  includePrivate: boolean;
  children: ReactNode;
};

export const AllServicesProvider = ({
  includePrivate,
  children,
}: AllServicesProviderProps) => {
  const context = useAllServicesLoader({ includePrivate });

  return (
    <AllServicesContext.Provider value={context}>
      {children}
    </AllServicesContext.Provider>
  );
};

export const useAllServices = () => {
  const context = useContext(AllServicesContext);
  if (context === undefined) {
    throw new Error('AllServicesProvider was not provided');
  }

  return context;
};
